/**
 * Validation schemas for the unified session form
 */

import { z } from 'zod';

/**
 * Session code validation schema
 */
export const sessionCodeSchema = z
  .string()
  .min(1, 'Session Code is required')
  .min(3, 'Session Code must be at least 3 characters')
  .max(10, 'Session Code must be 10 characters or less')
  .regex(/^[a-zA-Z0-9]+$/, 'Session Code can only contain letters and numbers')
  .transform((val) => val.toUpperCase());

/**
 * Player name validation schema
 */
export const playerNameSchema = z
  .string()
  .min(1, 'Your Name is required')
  .min(2, 'Your Name must be at least 2 characters')
  .max(50, 'Your Name must be 50 characters or less');

/**
 * Unified session form validation schema
 */
export const sessionFormSchema = z.object({
  sessionCode: sessionCodeSchema,
  playerName: playerNameSchema
});

/**
 * TypeScript type inferred from schema
 */
export type SessionFormData = z.infer<typeof sessionFormSchema>;
